const getPromiseValue = () => 'Promise{…}';
export default getPromiseValue;
